import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import SonicTeam from "../../common/classes/SonicTeam";
import {
  SonicDBEntry,
  SonicDBEntryData,
} from "../../common/classes/SonicDBEntry";
import { SonicUserData } from "../../common/classes/SonicUser";
import { getMembers } from "../../services/api/teams/getMembers";

interface teamDBState {
  total_entries: number;
  page: number;
  total_pages: number;
  teams: Array<SonicTeam>;
  owners: Array<SonicUserData>;
  pickups: Array<SonicTeam>;
  pickups_title?: string;
  members: Array<SonicDBEntryData>;
}

const initialState: teamDBState = {
  total_entries: 0,
  page: 0,
  total_pages: 0,
  teams: [],
  owners: [],
  pickups: [],
  pickups_title: undefined,
  members: [],
};

export const getMember = createAsyncThunk(
  "team/getMember",
  async (args: { id?: string; auth_token?: string }) => {
    const response = await getMembers(args.id, args.auth_token);

    if (response === null) return null;

    const entries: Array<SonicDBEntryData> = [];
    response.forEach((entry) =>
      entries.push(SonicDBEntry.serializeDBEntry(entry))
    );

    return entries;
  }
);

export const teamDBSlice = createSlice({
  name: "team",
  initialState,
  reducers: {
    clearTeamInfo: (state) => {
      state.total_entries = 0;
      state.page = 0;
      state.total_pages = 0;
      state.teams = [];
      state.owners = [];
      state.pickups = [];
      state.members = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMember.pending, (state) => {
        state.members = [];
      })
      .addCase(getMember.rejected, () => {})
      .addCase(getMember.fulfilled, (state, action) => {
        if (action.payload !== null) {
          state.members = action.payload;
        } else {
          state.members = [];
        }
      })
  },
});

export const { clearTeamInfo } = teamDBSlice.actions;
export default teamDBSlice.reducer;

export const getTeamData = (state: RootState) => state.team.teams;
export const getTeamOwners = (state: RootState) => state.team.owners;
export const getTeamMembers = (state: RootState) => state.team.members;
export const getTeamTotalEntries = (state: RootState) =>
  state.team.total_entries;
export const getTeamCurrentPage = (state: RootState) => state.team.page;
export const getTeamTotalPages = (state: RootState) => state.team.total_pages;
export const getPickupTeamData = (state: RootState) => state.team.pickups;
export const getPickupTeamTitle = (state: RootState) =>
  state.team.pickups_title;
